import { Button, CircularProgress, Grid } from '@material-ui/core';
import React, { memo } from 'react';
import { LoadMoreProps } from './load-more-props';
import './load-more.scss';

/**
 * Displays a load more button to support pagination.
 */
export const LoadMore: React.FC<LoadMoreProps> = memo((props) => {
  const {
    loading,
    onLoadMore,
    loadedNoun = 'animals',
  } = props;

  const loadMore = () => {
    onLoadMore();
  };

  return (
    <>
      <Grid container justify="center" className={`sg-load-more ${props.totalCount === props.loadedResults ? 'sg-load-more--hide' : ''}`}>
        <div className="sg-load-more__container">
          <p className="sg-load-more__text">You&apos;ve viewed {props.loadedResults} of {props.totalCount.toLocaleString()} {loadedNoun}</p>
          {
            props.totalCount > 500
            && <p className="sg-load-more__helper">Try selecting more parameters to refine search results</p>
          }
          {loading && (
            <div className="load-more__indicator">
              <CircularProgress color="primary" />
            </div>
          )}
          {!loading && (
            <Button className="sg-load-more__button" variant="outlined" onClick={loadMore}>load more</Button>
          )}
        </div>
      </Grid>
    </>
  );
});

// (LoadMore as any).whyDidYouRender = true;
